import { useIntl } from '@weenat/wintl';
import { useHasNotConfiguredPlot } from './useHasNotConfiguredPlot';
export const useDecitraitSeeExternalPlot = ({ plotId }) => {
    const { t } = useIntl();
    const { hasNotConfiguredPlot, isLoading } = useHasNotConfiguredPlot({ plotId });
    return {
        isLoading,
        hasNotConfiguredPlot,
        props: {
            seePlotLink: {
                _textAlign: 'center',
                href: 'https://decitrait.vignevin-epicure.com/',
                children: t('dss.decitrait.actions.see_epicure_interface')
            }
        }
    };
};
